import { fromJS } from 'immutable';
import {
  FETCH_PACKAGE_PAGE,
  FETCH_PACKAGE_PAGE_SUCCESS,
  FETCH_PACKAGE_PAGE_FAILURE,
  FETCH_PACKAGE_LOCATIONS,
  FETCH_PACKAGE_LOCATIONS_SUCCESS,
  FETCH_PACKAGE_LOCATIONS_FAILURE,
  FETCH_PACKAGE_PAGE_BY_LOCATION,
  SET_SELECTED_PACKAGE,
  SET_PACKAGE_QUANTITY,
  SET_SELECTED_PACKAGE_LOCATION,
  PURCHASE_PACKAGE,
  PURCHASE_PACKAGE_SUCCESS,
  PURCHASE_PACKAGE_FAILURE,
  CLEAR_PACKAGE_PURCHASE_DATA,
  CLEAR_PACKAGE_DATA,
} from './constants';

export const initialState = fromJS({
  fetchingPackagePage: false,
  fetchPackagePageError: null,
  packagePage: {},
  packageLocations: [],
  fetchingPackageLocations: false,
  fetchPackageLocationsError: null,
  selectedLocation: {},
  selectedPackage: {},
  quantity: 1,
  purchasingPackage: false,
  purchasingPackageError: null,
  purchasePackageResult: {},
});

function packageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PACKAGE_PAGE:
    case FETCH_PACKAGE_PAGE_BY_LOCATION:
      return state.withMutations(s => {
        s.set('fetchingPackagePage', true)
          .set('fetchPackagePageError', null)
          .set('packagePage', fromJS({}));
      });

    case FETCH_PACKAGE_PAGE_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingPackagePage', false)
          .set('fetchPackagePageError', null)
          .set('packagePage', fromJS(action.result));
      });

    case FETCH_PACKAGE_PAGE_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingPackagePage', false)
          .set('fetchPackagePageError', action.error)
          .set('packagePage', fromJS({}));
      });

    case FETCH_PACKAGE_LOCATIONS:
      return state.withMutations(s => {
        s.set('fetchingPackageLocations', true).set(
          'fetchPackageLocationsError',
          null,
        );
      });

    case FETCH_PACKAGE_LOCATIONS_SUCCESS:
      return state.withMutations(s => {
        s.set('fetchingPackageLocations', false)
          .set('fetchPackageLocationsError', null)
          .set('packageLocations', fromJS(action.items || []));
      });

    case FETCH_PACKAGE_LOCATIONS_FAILURE:
      return state.withMutations(s => {
        s.set('fetchingPackageLocations', false)
          .set('fetchPackageLocationsError', action.error)
          .set('packageLocations', fromJS([]));
      });

    case SET_SELECTED_PACKAGE_LOCATION:
      return state.set('selectedLocation', fromJS(action.location || {}));

    case SET_SELECTED_PACKAGE:
      return state.set('selectedPackage', fromJS(action.selectedPackage));

    case SET_PACKAGE_QUANTITY:
      return state.set('quantity', action.quantity);

    case PURCHASE_PACKAGE:
      return state.withMutations(s => {
        s.set('purchasingPackage', true)
          .set('purchasingPackageError', null)
          .set('purchasePackageResult', fromJS({}));
      });

    case PURCHASE_PACKAGE_SUCCESS:
      return state.withMutations(s => {
        s.set('purchasingPackage', false)
          .set('purchasingPackageError', null)
          .set('purchasePackageResult', fromJS(action.result));
      });

    case PURCHASE_PACKAGE_FAILURE:
      return state.withMutations(s => {
        s.set('purchasingPackage', false)
          .set('purchasingPackageError', action.error)
          .set('purchasePackageResult', fromJS({}));
      });

    case CLEAR_PACKAGE_PURCHASE_DATA:
      return state.withMutations(s => {
        s.set('purchasingPackage', false)
          .set('purchasingPackageError', null)
          .set('purchasePackageResult', fromJS({}));
      });

    case CLEAR_PACKAGE_DATA:
      return initialState;

    default:
      return state;
  }
}

export default packageReducer;
